'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _blocks = require('../../blocks');

var _menuPropTypes = require('./menuPropTypes');

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function evaluateMenuSubItemActive(currentPath, itemPath) {
  return currentPath && currentPath.endsWith(itemPath);
}

function MenuSubItem(_ref) {
  var TextRenderer = _ref.TextRenderer,
      isFlyoutOpen = _ref.isFlyoutOpen,
      location = _ref.location,
      menuSubItem = _ref.menuSubItem;

  var isActive = evaluateMenuSubItemActive(location.pathname, menuSubItem.path);

  return _react2.default.createElement(
    _blocks.LeftNav.MenuSubItem,
    null,
    menuSubItem.url ? _react2.default.createElement(
      _blocks.LeftNav.MenuSubItemA,
      {
        'aria-label': menuSubItem.message,
        href: menuSubItem.url,
        modifiers: (0, _lodash.compact)([isActive && 'active', isFlyoutOpen && 'flyout']),
        target: '_blank'
      },
      _react2.default.createElement(TextRenderer, { message: menuSubItem.message })
    ) : _react2.default.createElement(
      _blocks.LeftNav.MenuSubItemLink,
      {
        'aria-label': menuSubItem.message,
        to: menuSubItem.path,
        modifiers: (0, _lodash.compact)([isActive && 'active', isFlyoutOpen && 'flyout'])
      },
      _react2.default.createElement(TextRenderer, { message: menuSubItem.message })
    )
  );
}

MenuSubItem.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  isFlyoutOpen: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  // eslint-disable-next-line react/no-typos
  menuSubItem: _menuPropTypes2.default.menuSubItem.isRequired
};

MenuSubItem.defaultProps = {
  isFlyoutOpen: false
};

exports.default = MenuSubItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/LeftNav/MenuSubItem.js
// module id = 729
// module chunks = 2